import React from 'react';
import MainSidebar from './MainSidebar';
import { FiBriefcase, FiCheckSquare } from 'react-icons/fi';

export default function ProjectSidebar() {
  const menuItems = [
    {
      id: 'projects_main',
      title: 'Projects & Leads',
      links: [
        { path: '/projects', label: 'Projects List', icon: FiBriefcase },
        { path: '/projects/tasks', label: 'Tasks (Kanban)', icon: FiCheckSquare }
      ]
    }
  ];

  return <MainSidebar moduleName="Projects & Tasks" menuItems={menuItems} />;
}